<ng-content></ng-content>
<ng-content select="tix-card-footer"></ng-content>
